let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '购买订单编号',
        props: 'walletListNo',
        minWidth: 220,
    },
    {
        label: '用户手机号',
        props: 'mobile',
        minWidth: 200,
    },
    {
        label: '购买类型',
        props: 'pileUseServiceName',
        minWidth: 180,
    },
    {
        label: '购买名称',
        props: 'packagName',
        minWidth: 280,
    },
    {
        label: '购买内容',
        props: 'equityContent',
        minWidth: 320,
    },
    {
        label: '购买全额（元）',
        props: 'actInExpAmount',
        minWidth: 200,
    },
    {
        label: '购买时间',
        props: 'transactionSucceedTime',
        minWidth: 200,
    },
    {
        label: '支付方式',
        props: 'transactionChannelName',
        minWidth: 200,
    },
    {
        label: '交易流水号',
        props: 'walletNo',
        minWidth: 200,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '订单管理'
    },
    {
        type: 'title',
        name: '支付订单管理'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 列表-详情操作
// pageConfig.tableDetailObj = {
//     editKey: 'id',
//     editRouter: 'pileDetailTab',
// };

// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.listRouter = 'pileList';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '充电桩管理',
        router: 'pileList'
    },
    {
        type: 'title',
        name: '充电桩详情'
    }
];

// 关联账号 详情面包屑
pageConfig.relationBreadCrunm = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '充电桩管理',
        router: 'pileList'
    },
    {
        type: 'title',
        name: '关联账号详情'
    }
]

pageConfig.formRules = {
    pileCode: [{ required: true, message: '请输入IMEI号', trigger: 'blur' }],
    pileTypeNo: [{ required: true, message: '请选择充电桩型号名称', trigger: 'change' }],
    currentOutType: [{ required: true, message: '请选择电流输出类型', trigger: 'change' }],
    gunNum: [{ required: true, message: '请输入充电桩枪数', trigger: 'blur' }],
    //dealName: [{ required: true, message: '请选择经销商名称', trigger: 'change' }],
    optType: [{ required: true, message: '请选择充电桩类型', trigger: 'change' }],
    chargingSpeed: [{ required: true, message: '请选择充电速度', trigger: 'change' }],
    interfaceType: [{ required: true, message: '请选择接口标准', trigger: 'change' }],
    applyReason: [{ required: true, message: '请填写申请原因', trigger: 'blur' }],
    repairPerson: [{ required: true, message: '请填写维修人', trigger: 'blur' }],
    repairStatus: [{ required: true, message: '请选择维修状态', trigger: 'change' }],
    repairResult: [{ required: true, message: '请选择维修结果', trigger: 'change' }],
    repairDateNum: [{ required: true, message: '请填写维修时间', trigger: 'blur' }],
    corpReturn: [{ required: true, message: '请填写运营商回执', trigger: 'blur' }],
};



export default pageConfig;
